export { default } from './DocumentRecordModal';
